module.exports = __webpack_public_path__ + "img/warningIcon.f70dd72c.svg";